module.exports = require("core-js/library/fn/number/is-nan");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/number/is-nan.js